<template>
	<div class="try">
		<h1>
			Saludo model vue -> {{message}}			
		</h1>
		<h1>
			Saludo prop pasado desde rails -> {{greeting}}
		</h1>
		<h1>
			Vuex -> {{ tryVuex }}
		</h1>
		<button type="button" class="btn btn-primary" @click="changeValue">Cambiar valor vuex</button>

	</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	name: 'Try',
	props: ['greeting'],
	computed: {
		tryVuex: {
			get () {
				return this.$store.state.tryVuex
			},
			set (value){
				this.$store.commit('changeTryVuex', value)				
			}
		},
	},
	methods: {
		changeValue() {
			this.tryVuex = 'Cambio de valor prueba.......'			
			console.log("changeValue -> " + this.tryVuex)
		}
	},
	data() {
		return {
			message: 'Hola Mundo Vue'
		}
	},
	created () {
	  console.log(this.$store);
	},

}
</script>
<style scoped>
 	.login-footer {
	 background-color: #e6e6e6;
 }
</style>